/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Step_ReviewInputs */

const en_directory_submit_step_review = /** @type {(inputs: Directory_Submit_Step_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const zh_directory_submit_step_review = /** @type {(inputs: Directory_Submit_Step_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Directory_Submit_Step_ReviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_step_review = /** @type {((inputs?: Directory_Submit_Step_ReviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Step_ReviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_step_review(inputs)
	return zh_directory_submit_step_review(inputs)
});
export { directory_submit_step_review as "directory.submit.step_review" }